import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const dataList = [
  {
    title: 'Write About It',
    desc: "Create a review, tutorial, or comparison article to show how Dolphin Radar works. Your readers trust your recommendations, so share why you think it's a must-have tool. Add your referral link so you earn every time someone signs up.",
    image: '/images/affiliates/p-1.webp',
  },
  {
    title: 'Post on Social Media',
    desc: 'Share Dolphin Radar on your favorite platforms—Instagram, Facebook, Twitter, Reddit, or anywhere your audience spends time. Highlight what makes it a powerful all-in-one tool and why you recommend it. You can share quick posts, stories, videos, or discussions with your referral link to start earning.',
    image: '/images/affiliates/p-2.webp',
  },
  {
    title: 'Create a Video',
    desc: 'Record a quick walkthrough or demo to show how Dolphin Radar works. Videos are a great way to build trust and help viewers see the benefits in action. Include your link in the description so you earn commissions on every sign-up.',
    image: '/images/affiliates/p-3.webp',
  },
];
export default function Promote() {
  const { t } = useTranslation('common');
  return (
    <div className="lg:py-20 py-10 bg-[#291C75] lg:px-0 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="lg:text-5xl text-3xl font-bold text-white text-center mb-4">
          {t('How to Promote Dolphin Radar')}
        </h2>
        <p className="lg:text-lg text-base text-white/50 text-center lg:w-[600px] w-full mx-auto">
          {t(
            'Ready to start promoting? Here are some easy ways to share Dolphin Radar and grow your earnings. Pick the channels that fit you best.'
          )}
        </p>

        <div className="grid lg:grid-cols-3 grid-cols-1 lg:mt-24 mt-10 max-w-[1000px] mx-auto lg:gap-1 gap-8">
          {dataList.map((item, index) => (
            <div key={index} className="relative p-2 items-start flex flex-col h-full">
              <div className="bg-white rounded-2xl border border-gray-200 shadow p-4 px-6 lg:pt-[200px] pt-[260px] flex-1 flex flex-col">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{t(item.title)}</h3>
                <p className="text-gray-500 mb-2 flex-1">{t(item.desc)}</p>
              </div>
              <Image
                src={item.image}
                alt={item.title}
                width={904}
                height={640}
                className={`rounded-2xl w-full absolute lg:-top-10 -top-4 ${
                  index === 0 ? 'lg:-left-4 -left-1' : index === 1 ? 'left-0' : 'right-0'
                } scale-110`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
